import { GreyGrey90, Primary13Regular, Box } from '@sequencehq/core-components'

export const SlackIntegrationDetail = () => {
  return (
    <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
      Stay up to date with real-time notifications for Sequence events.
    </Box>
  )
}
